import Swiper from "swiper";
import { Navigation, EffectFade } from "swiper/modules";
//import "swiper/swiper-bundle.css";

window.addEventListener("load", () => {
    const teamSlider = document.querySelector('.section-team');
    if(!teamSlider) return;

    const nextEl = teamSlider.querySelector('.swiper-button-next');
    const prevEl = teamSlider.querySelector('.swiper-button-prev');

    nextEl.innerHTML = '<svg width="18" height="19" viewBox="0 0 18 19" fill="none"><path d="M11.5023 4.32812L17 9.57813L11.4028 9.56422C13.4055 9.56927 14.3959 7.13374 12.9581 5.73963L11.5023 4.32812Z" fill="#012027"/><path d="M17 9.57813L13.3349 13.0781L11.5023 14.8281L12.9549 13.4309C14.411 12.0303 13.4231 9.56928 11.4028 9.56422L17 9.57813Z" fill="#012027"/><path d="M0.999999 9.57813L11.4028 9.56422M17 9.57813L13.3349 13.0781L11.5023 14.8281M17 9.57813L11.5023 4.32812M17 9.57813L11.4028 9.56422M9.66975 16.5781L11.5023 14.8281M9.66974 2.57813L11.5023 4.32812M11.5023 14.8281L12.9549 13.4309C14.411 12.0303 13.4231 9.56928 11.4028 9.56422V9.56422M11.5023 4.32812L12.9581 5.73963C14.3959 7.13374 13.4055 9.56927 11.4028 9.56422V9.56422" stroke="#012027" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    prevEl.innerHTML = '<svg width="18" height="19" viewBox="0 0 18 19" fill="none"><path d="M6.49769 14.6719L0.999999 9.42187L6.59723 9.43578C4.5945 9.43073 3.60406 11.8663 5.0419 13.2604L6.49769 14.6719Z" fill="#012027"/><path d="M0.999999 9.42187L4.66513 5.92187L6.49769 4.17187L5.04506 5.56914C3.58897 6.96973 4.57687 9.43072 6.59723 9.43578L0.999999 9.42187Z" fill="#012027"/><path d="M17 9.42187L6.59723 9.43578M0.999998 9.42187L4.66513 5.92187L6.49769 4.17187M0.999998 9.42187L6.49769 14.6719M0.999998 9.42187L6.59723 9.43578M8.33025 2.42187L6.49769 4.17187M8.33025 16.4219L6.49769 14.6719M6.49769 4.17187L5.04506 5.56914C3.58897 6.96973 4.57687 9.43072 6.59723 9.43578V9.43578M6.49769 14.6719L5.0419 13.2604C3.60406 11.8663 4.5945 9.43073 6.59723 9.43578V9.43578" stroke="#012027" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    new Swiper(teamSlider.querySelector('.section-team__main-thumb'), {
      modules: [Navigation],
      loop: true,
      speed: 500,
      spaceBetween: 25,
      slidesPerView: 'auto',
      initialSlide: 1,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
    });

    new Swiper(teamSlider.querySelector('.section-team__main'), {
      modules: [Navigation, EffectFade],
      loop: true,
      speed: 500,
      spaceBetween: 25,
      slidesPerView: 1,
      autoHeight: true,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      breakpoints: {
        1024: {
          autoHeight: true,
        },
      },
    });
});
